var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_950_673)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3499 34.2451L51.0032 45.6731L39.4366 57.2064C39.2478 56.9597 39.101 56.6836 39.0019 56.3891C38.9499 56.0556 38.9499 55.716 39.0019 55.3824V35.7558C38.9672 35.2291 39.0886 34.7024 39.3486 34.2451M56.0232 40.6891L52.2192 44.4571L40.7046 33.1331C41.0779 33.0038 41.4779 32.9678 41.8686 33.0291C42.4819 33.1971 43.0672 33.4558 43.6046 33.7931L54.0259 39.5598C54.7032 39.9238 55.3632 40.3064 56.0232 40.6891ZM52.2206 46.9064L56.0059 50.6238L53.2619 52.1518L44.8899 56.8051C44.1966 57.1878 43.5006 57.5531 42.8232 57.9704C42.5335 58.151 42.2085 58.2677 41.87 58.3125C41.5315 58.3573 41.1874 58.3294 40.8606 58.2304L52.2206 46.9064ZM62.0339 45.6731C62.0444 46.1395 61.9269 46.5998 61.6941 47.0041C61.4614 47.4084 61.1224 47.7412 60.7139 47.9664L57.5859 49.7024L53.4699 45.6731L57.6032 41.5744C58.6632 42.1651 59.7059 42.7558 60.7472 43.3118C61.1627 43.5437 61.504 43.8886 61.7315 44.3065C61.959 44.7244 62.0647 45.1983 62.0339 45.6731Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_950_673",
    x: 0.5,
    y: 0,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_950_673"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_950_673",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/Playstore.1b7eea9f41aa44d1ed414250eb8b55a3.svg";
export { ForwardRef as ReactComponent };